'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps; /**
                                      * Created by lyj on 2016/5/16.
                                      */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCreateFragment = require('react-addons-create-fragment');

var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);

var _PageView = require('./PageView');

var _PageView2 = _interopRequireDefault(_PageView);

var _BreakView = require('./BreakView');

var _BreakView2 = _interopRequireDefault(_BreakView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationBoxView = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PaginationBoxView, _Component);

  function PaginationBoxView(props) {
    (0, _classCallCheck3.default)(this, PaginationBoxView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PaginationBoxView).call(this, props));

    _initialiseProps.call(_this);

    var selected = 0;
    if (props.initialSelected) {
      selected = props.initialSelected;
    } else if (props.forceSelected) {
      selected = props.forceSelected;
    }
    _this.state = {
      selected: selected
    };
    return _this;
  }

  (0, _createClass3.default)(PaginationBoxView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Call the callback with the initialSelected item:
      if (typeof this.props.initialSelected !== 'undefined') {
        this.callCallback(this.props.initialSelected);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.forceSelected !== 'undefined' && this.props.forceSelected !== nextProps.forceSelected) {
        this.setState({ selected: nextProps.forceSelected });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var disabled = this.props.disabledClassName;

      var previousClasses = (0, _classnames2.default)(this.props.previousClassName, (0, _defineProperty3.default)({}, disabled, this.state.selected === 0));

      var nextClasses = (0, _classnames2.default)(this.props.nextClassName, (0, _defineProperty3.default)({}, disabled, this.state.selected === this.props.pageNum - 1));

      return _react2.default.createElement(
        'ul',
        { className: this.props.containerClassName },
        _react2.default.createElement(
          'li',
          { onClick: this.handlePreviousPage, className: previousClasses },
          _react2.default.createElement(
            'a',
            { className: this.props.previousLinkClassName },
            this.props.previousLabel
          )
        ),
        (0, _reactAddonsCreateFragment2.default)(this.pagination()),
        _react2.default.createElement(
          'li',
          { onClick: this.handleNextPage, className: nextClasses },
          _react2.default.createElement(
            'a',
            { className: this.props.nextLinkClassName },
            this.props.nextLabel
          )
        )
      );
    }
  }]);
  return PaginationBoxView;
}(_react.Component), _class.propTypes = {
  pageNum: _react.PropTypes.number.isRequired,
  pageRangeDisplayed: _react.PropTypes.number.isRequired,
  marginPagesDisplayed: _react.PropTypes.number.isRequired,
  previousLabel: _react.PropTypes.node,
  nextLabel: _react.PropTypes.node,
  breakLabel: _react.PropTypes.node,
  clickCallback: _react.PropTypes.func,
  initialSelected: _react.PropTypes.number,
  forceSelected: _react.PropTypes.number,
  containerClassName: _react.PropTypes.string,
  pageClassName: _react.PropTypes.string,
  pageLinkClassName: _react.PropTypes.string,
  activeClassName: _react.PropTypes.string,
  previousClassName: _react.PropTypes.string,
  nextClassName: _react.PropTypes.string,
  previousLinkClassName: _react.PropTypes.string,
  nextLinkClassName: _react.PropTypes.string,
  disabledClassName: _react.PropTypes.string
}, _class.defaultProps = {
  pageNum: 10,
  pageRangeDisplayed: 2,
  marginPagesDisplayed: 3,
  activeClassName: 'selected',
  previousClassName: 'previous',
  nextClassName: 'next',
  previousLabel: 'Previous',
  nextLabel: 'Next',
  breakLabel: '...',
  disabledClassName: 'disabled'
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handlePreviousPage = function (evt) {
    if (evt.preventDefault) {
      evt.preventDefault();
    } else {
      evt.returnValue = false;
    }
    if (_this2.state.selected > 0) {
      _this2.handlePageSelected(_this2.state.selected - 1, evt);
    }
  };

  this.handleNextPage = function (evt) {
    if (evt.preventDefault) {
      evt.preventDefault();
    } else {
      evt.returnValue = false;
    }
    if (_this2.state.selected < _this2.props.pageNum - 1) {
      _this2.handlePageSelected(_this2.state.selected + 1, evt);
    }
  };

  this.handlePageSelected = function (selected, evt) {
    if (evt.preventDefault) {
      evt.preventDefault();
    } else {
      evt.returnValue = false;
    }

    if (_this2.state.selected === selected) return;

    _this2.setState({ selected: selected });

    // Call the callback with the new selected item:
    _this2.callCallback(selected);
  };

  this.callCallback = function (selectedItem) {
    if (typeof _this2.props.clickCallback !== 'undefined' && typeof _this2.props.clickCallback === 'function') {
      _this2.props.clickCallback({ selected: selectedItem });
    }
  };

  this.pagination = function () {
    var items = {};

    if (_this2.props.pageNum <= _this2.props.pageRangeDisplayed) {
      for (var index = 0; index < _this2.props.pageNum; index++) {
        items['key' + index] = _react2.default.createElement(_PageView2.default, {
          onClick: _this2.handlePageSelected.bind(null, index),
          selected: _this2.state.selected === index,
          pageClassName: _this2.props.pageClassName,
          pageLinkClassName: _this2.props.pageLinkClassName,
          activeClassName: _this2.props.activeClassName,
          page: index + 1 });
      }
    } else {
      var leftSide = _this2.props.pageRangeDisplayed / 2;
      var rightSide = _this2.props.pageRangeDisplayed - leftSide;

      if (_this2.state.selected > _this2.props.pageNum - 1 - _this2.props.pageRangeDisplayed / 2) {
        rightSide = _this2.props.pageNum - _this2.state.selected - 1;
        leftSide = _this2.props.pageRangeDisplayed - rightSide;
      } else if (_this2.state.selected < _this2.props.pageRangeDisplayed / 2) {
        leftSide = _this2.state.selected;
        rightSide = _this2.props.pageRangeDisplayed - leftSide;
      }

      var _index = void 0;
      var page = void 0;
      var breakView = void 0;

      for (_index = 0; _index < _this2.props.pageNum; _index++) {
        page = _index + 1;

        var pageView = _react2.default.createElement(_PageView2.default, {
          onClick: _this2.handlePageSelected.bind(null, _index),
          selected: _this2.state.selected === _index,
          pageClassName: _this2.props.pageClassName,
          pageLinkClassName: _this2.props.pageLinkClassName,
          activeClassName: _this2.props.activeClassName,
          page: _index + 1 });

        if (page <= _this2.props.marginPagesDisplayed) {
          items['key' + _index] = pageView;
          continue;
        }

        if (page > _this2.props.pageNum - _this2.props.marginPagesDisplayed) {
          items['key' + _index] = pageView;
          continue;
        }

        if (_index >= _this2.state.selected - leftSide && _index <= _this2.state.selected + rightSide) {
          items['key' + _index] = pageView;
          continue;
        }

        var keys = (0, _keys2.default)(items);
        var breakLabelKey = keys[keys.length - 1];
        var breakLabelValue = items[breakLabelKey];

        if (_this2.props.breakLabel && breakLabelValue !== breakView) {
          breakView = _react2.default.createElement(_BreakView2.default, { breakLabel: _this2.props.breakLabel });

          items['key' + _index] = breakView;
        }
      }
    }

    return items;
  };
}, _temp);
exports.default = PaginationBoxView;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Paginate/Paginate.js
 ** module id = 1390
 ** module chunks = 0
 **/